import { TwilioLogType } from '@hakimo-ui/hakimo/types';
import { getCallDetailsNode } from '../twilio-call-details/TwilioCallDetails';
import { getSMSDetailsNode } from './TwilioSMSDetails';
import { isSmsLog } from './utils';

interface TwilioLogUpdate {
  twilio_ssid?: string;
  twilio_calling_to_name?: string;
  twilio_log_type?: TwilioLogType;
  user?: { name?: string };
  s3_urls?: string[];
}

export const getTwilioLogDescriptionNode = (
  update: TwilioLogUpdate,
  options: { alarmGroupId?: string; locationAlarmId?: string } = {}
) => {
  if (!update.twilio_ssid) {
    return 'Twilio SSID not found';
  }
  if (isSmsLog(update)) {
    return getSMSDetailsNode(
      update.twilio_ssid,
      update.twilio_calling_to_name,
      update.user?.name,
      update.s3_urls
    );
  }
  return getCallDetailsNode(
    update.twilio_ssid,
    update.twilio_calling_to_name,
    update.user?.name,
    options.alarmGroupId,
    options.locationAlarmId
  );
};
